/**
 * Created by alexandreroitman on 26/05/2016.
 */
define([
    'prop-types',
    'lodash',
    'componentsCore',
    'skins',
    'radioButton/skins/skins.json',
    'santa-components'
], function (PropTypes, _, componentsCore, skinsPackage, skinsJson, santaComponents) {
    'use strict';

    const radioButton = {
        displayName: 'RadioButton',
        mixins: [componentsCore.mixins.skinBasedComp, santaComponents.mixins.runTimeCompData],

        propTypes: {
            compData: santaComponents.santaTypesDefinitions.Component.compData,
            compProp: santaComponents.santaTypesDefinitions.Component.compProp.isRequired,
            groupName: PropTypes.string,
            invalid: PropTypes.bool,
            validityIndication: PropTypes.bool,
            checked: PropTypes.bool,
            onChange: PropTypes.func,
            text: PropTypes.string,
            marginBottom: PropTypes.number,
            marginRight: PropTypes.number
        },

        getStyle() {
            const {marginBottom, marginRight} = this.props;
            if (marginBottom) {
                return {marginBottom};
            }
            if (marginRight) {
                return {marginRight};
            }
            return {};
        },

        getSkinProperties() {
            const rootClassSet = {
                invalid: this.props.invalid,
                'with-validation-indication': this.props.validityIndication
            };
            rootClassSet[`${this.props.compProp.alignment}-direction`] = true;

            const marginDirection = `margin${_.capitalize(this.props.compProp.alignment)}`;
            const textStyle = this.props.textStyle || {};
            textStyle[marginDirection] = _.get(this.props, 'compProp.spacing', 0) + 1;


            const circleShadowStyle = {
                width: this.props.compProp.buttonSize,
                minWidth: this.props.compProp.buttonSize,
                height: this.props.compProp.buttonSize
            };

            const disabled = !!this.props.compProp.isDisabled;

            // todod - handle real invalid
            const error = _.get(this, 'props.compProp.data-error', false);
            const preview = this.getComponentPreviewState() || this.props.previewState;

            const buttonWidth = this.props.layout === 'horizontal' ? `${(100 / this.props.numOfOptions).toString()}%` : '100%';

            const radioSkin = {
                '': {
                    'data-disabled': disabled,
                    style: _.merge({}, {width: buttonWidth}, this.getStyle()),
                    className: this.classSet(rootClassSet)
                },
                'radio-input': {
                    disabled,
                    required: this.props.compProp.required,
                    onChange: this.props.onChange || _.noop,
                    name: this.props.groupName,
                    checked: !!this.props.checked
                },
                'circle-shadow': {
                    style: circleShadowStyle
                },
                'circle': {
                    'data-disabled': disabled,
                    'data-preview': preview
                },
                'container': {
                    'data-preview': preview,
                    'data-disabled': disabled,
                    'data-error': error
                },
                'text': {
                    children: [_.get(this.props, 'compData.label', '')],
                    style: textStyle
                }

            };

            return radioSkin;
        }
    };

    componentsCore.compRegistrar.register('wysiwyg.viewer.components.inputs.RadioButton', radioButton);
    skinsPackage.skinsMap.addBatch(skinsJson);

    return radioButton;
});
